var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"button"}},[_c('div',{class:("container " + (_vm.size === 'large' ? 'large' : _vm.size) + "  " + (_vm.active ? '' : 'deactive')),style:({
            'background-color': _vm.bgColor,
            padding: (_vm.paddingY + " 0px"),
            border: _vm.border,
            borderRadius: _vm.borderRadius,
        }),on:{"click":function($event){return _vm.btnClickHandler()}}},[_c('div',{staticClass:"button",style:({ color: _vm.txtColor })},[_vm._t("default")],2)])])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7c53c597","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/common/Button.vue
// module id = C3AT
// module chunks = 0